import { API_Handler } from "./API_Handler";
import { encryptData } from "../Utilities/EncryptData";

export const Utr_APIs = {
    Submit_Utr: async (Request, Token) => await API_Handler.post(`/transaction/utr-deposit`, { token: encryptData(Request) }, { headers: { Authorization: `Bearer ${Token}` } }),
    Get_Utr_Data: async (Request, Token) => await API_Handler.post(`/utrProvider/getActiveUtr`, { token: encryptData(Request) }, { headers: { Authorization: `Bearer ${Token}` } }),
}